import {theme} from "../../../../utils";

export interface IPrivacyPolicyDialogProps {
    onClosePrivacyPolicyDialog?: () => void;
    showPrivacyPolicyDialog: boolean;
    contentData?: any;
}

export const privacyPolicyDialogStyles = {
    cancelButtonWrapper: {
        borderRadius: "8px",
        textTransform: "capitalize",
        height: "38px",
        width: '197px'
    },
    continueButtonWrapper: {
        borderRadius: "8px",
        textTransform: "capitalize",
        height: "38px",
        width: '197px'
    },
    contentLabel: {
        ...theme.typography.body1Regular,
        fontSize: "16px",
        mb: "1.875rem",
        color: "#484A4C"
    },
    headerTitleSx: {
        ...theme.typography.opticianBodyRegular,
        fontSize: "24px",
        color: "#252525",
        textAlign: 'center',
    },
    headerSubTitleSx: {
        ...theme.typography.poppinsBodyLight,
        textAlign: 'center',
        lineHeight: "24px",
        mt: "8px",
        fontWeight: 600,
    }
}
